<template>
  <layout ribbon="Digest">
    <Markdown />
  </layout>
</template>

<script>
import Layout from '../layouts/index'
import Markdown from "../../statics/markdowns/weekly-github-digest/20.md";

export default {
  name: "app",
  data() {
    return {};
  },
  components: {
    Layout,
    Markdown
  }
};
</script>

<style scoped lang="scss">
</style>